import { render, staticRenderFns } from "./cardVisit.vue?vue&type=template&id=685dae4d&scoped=true"
import script from "./cardVisit.vue?vue&type=script&lang=js"
export * from "./cardVisit.vue?vue&type=script&lang=js"
import style0 from "./cardVisit.vue?vue&type=style&index=0&id=685dae4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685dae4d",
  null
  
)

export default component.exports